angular.module('qkr.merchant.reports')
    .controller('ScheduleReportsController', function($uibModal, merchantInfo, utils, $routeSegment,
                                                      APP_CONSTANT, outletService) {
        const vm = this;
        // vm.reports = addDate(reports);

        vm.scheduleTransactionsReport = () => {
            const accountancyPackageName = merchantInfo.accountancyPackage ? merchantInfo.accountancyPackage.name : '';

            const modalInstance = $uibModal.open({
                template: require('./transaction.outlet.html'),
                controller: 'TransactionOutletController',
                windowClass: 'modal-huge',
                backdrop: 'static',
                resolve: {
                    reportInfo() {
                        return {
                            reportType: accountancyPackageName
                        };
                    },
                    savedReport() {
                        return null;
                    },
                    departments() {
                        return outletService.loadOutletDepartments($routeSegment.$routeParams.outletId);
                    },
                    isMerchantReport() {
                        return false;
                    },
                    outlets() {
                        return outletService.listOutlets();
                    }
                }
            });
            modalInstance.result
                .then(() => $routeSegment.chain[1].reload())
                .catch(() => console.log('fail'));
        };

        vm.scheduleStickersReport = () => {
            const modalInstance = $uibModal.open({
                template: require('./sticker.html'),
                controller: 'StickerController',
                windowClass: 'modal-huge',
                backdrop: 'static',
                resolve: {
                    savedReport() {
                        return null;
                    }
                }
            });

            modalInstance.result
                .then(() => $routeSegment.chain[1].reload())
                .catch(() => console.log('fail'));
        };

        vm.scheduleTallyReport = () => {
            const modalInstance = $uibModal.open({
                template: require('./tally.html'),
                controller: 'TallyController',
                windowClass: 'modal-huge',
                backdrop: 'static',
                resolve: {
                    savedReport() {
                        return null;
                    }
                }
            });

            modalInstance.result
                .then(() => $routeSegment.chain[1].reload())
                .catch(() => console.log('fail'));
        };

        vm.scheduleAccountancyReport = () => {
            const accountancyPackageName = merchantInfo.accountancyPackage ?
                merchantInfo.accountancyPackage.name : null;
            // QKRD-2035 - support all accountancy packages

            let modalInstance;
            if (accountancyPackageName === 'ICON') {
                modalInstance = $uibModal.open({
                    template: require('./reconciliation.html'),
                    controller: 'ReconciliationControllerModal as vm',
                    windowClass: 'modal-huge',
                    backdrop: 'static',
                    resolve: {
                        reportInfo() {
                            return {
                                reportType: accountancyPackageName,
                                report: null
                            };
                        },
                        departments() {
                            return outlets;
                        }
                    }
                });
            } else if (accountancyPackageName === APP_CONSTANT.FINANCE1_REPORT) {
                modalInstance = $uibModal.open({
                    template: require('./finance1.html'),
                    controller: 'Finance1ControllerModal as vm',
                    windowClass: 'modal-huge',
                    backdrop: 'static',
                    resolve: {
                        reportInfo() {
                            return {
                                reportType: accountancyPackageName,
                                report: null
                            };
                        },
                        departments() {
                            return outlets;
                        }
                    }
                });
            } else {
                modalInstance = $uibModal.open({
                    template: require('./cases21.html'),
                    controller: 'Cases21ControllerModal',
                    windowClass: 'modal-huge',
                    backdrop: 'static',
                    resolve: {
                        reportInfo() {
                            return {
                                reportType: accountancyPackageName,
                                report: null
                            };
                        }
                    }
                });
            }

            modalInstance.result
                .then(() => $routeSegment.chain[1].reload())
                .catch(() => console.log('fail'));
        };


        vm.scheduleStockLevel = () => {
            const modalInstance = $uibModal.open({
                template: require('./stock.html'),
                controller: 'StockController',
                windowClass: 'modal-huge',
                backdrop: 'static',
                resolve: {
                    savedReport() {
                        return null;
                    }
                }
            });

            modalInstance.result
                .then(() => $routeSegment.chain[1].reload())
                .catch(() => console.log('fail'));
        };

        function addDate(reports) {
            return reports.map(report => {
                if (report.suspended) {
                    report.nextScheduledGenerationDisplay = utils
                        .serverDateStringtoDate(report.nextScheduledGenerationDisplay);
                }
                return report;
            });
        }

    });



// WEBPACK FOOTER //
// ./src/reports/outlet/schedule/schedule.controller.js